import { render, staticRenderFns } from "./CourseLiveOnline.vue?vue&type=template&id=3030c6dc&scoped=true&"
import script from "./CourseLiveOnline.vue?vue&type=script&lang=js&"
export * from "./CourseLiveOnline.vue?vue&type=script&lang=js&"
import style0 from "./CourseLiveOnline.vue?vue&type=style&index=0&id=3030c6dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3030c6dc",
  null
  
)

export default component.exports